module.exports = __webpack_public_path__ + "img/rectangle.dfcdaca7.png";